import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";

import { addLineBreaks } from "./LineBreaks";

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#dff0d8",
    borderColor: "#7d8675",
    color: "#3c763d",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export default function DialogBodyMnp() {
  const classes = useStyles();
  const noteText = addLineBreaks(`Note:
                                1. Retailers are sorted basis Last full month MNP activations.
                                `);

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Parameters</StyledTableCell>
            <StyledTableCell align="center">Red</StyledTableCell>
            <StyledTableCell align="center">Amber</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell component="th" scope="row">
              <Typography gutterBottom> MTD MNP Actn</Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {
                  "Visit Retailers for explaining Jio VS Competition offerings, Perfecting sales pitch for conversion & Additional Payout Benefits"
                }
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {
                  "Call Retailers Emphasizing on MNP conversions and additional benefits in payout."
                }
              </Typography>
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell component="th" scope="row" colSpan={3}>
              <Typography gutterBottom>{noteText}</Typography>
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
